/**
 * OVERVIEW is the default tab
 */
enum ACCOUNT_TAB {
  OVERVIEW = 'overview',
  REVIEWS = 'reviews',
  GOALS = 'goals',
  ANALYTICS = 'analytics',
  DOCUMENTS = 'documents',
  DEBUG = 'debug',
  INSTRUCTIONS = 'requirements',
  NOTES = 'notes',
  RECOMMENDS = 'recommends',
  BUILDER = 'builder',
  TASKS = 'tasks',
  HISTORY = 'history',
}

export default ACCOUNT_TAB;
